import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom'; // Import Link from react-router-dom

const Header = () => {
	const navigate = useNavigate();
	
	return (
		<header>
			<div className="top-nav">
				 
					<div class="nav-inner">
					<div class="header-left" onClick={() => navigate('/admin/user-management')}>
				<a><img src={window.getPublicUrl("/assets/images/login-logo.svg")} alt="Main Logo"/></a>
			</div>
			<div class="header-right">
               <span></span>
			    <div className='header-right-text'>
					<h3>Abroad Bible Admin</h3>
					<h4>admin@gmail.com</h4>
				</div>
			</div>
						{/* <div class="nav-links">
							<a href=""><img src={window.getPublicUrl('/assets/images/instagram-white.svg')} alt="" /></a>
							<a href=""><img src={window.getPublicUrl('/assets/images/fb-white.svg')} alt="" /></a>
							<a href=""><img src={window.getPublicUrl('/assets/images/music-white.svg')} alt="" /></a>
						</div> */}
					</div>
				 
			</div>
		</header>
	);
}
export default Header;
